import { render, staticRenderFns } from "./AddAppointment.vue?vue&type=template&id=56d6fa42&scoped=true"
import script from "./AddAppointment.vue?vue&type=script&lang=js"
export * from "./AddAppointment.vue?vue&type=script&lang=js"
import style0 from "./AddAppointment.vue?vue&type=style&index=0&id=56d6fa42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6fa42",
  null
  
)

export default component.exports